import KEY_CODES from '../../constants/keys.constants';
const KONAMI_TYPE_DELAY = 1000;

class JfBintrayKonamiController {
	constructor($scope, $element, $attrs, $document, $timeout) {
		this.$scope = $scope;
		this.$element = $element;
		this.$document = $document;
		this.$timeout = $timeout;
		this.konamiCode =  `${KEY_CODES.UP_ARROW}`+
						   `${KEY_CODES.UP_ARROW}`+
						   `${KEY_CODES.DOWN_ARROW}`+
						   `${KEY_CODES.DOWN_ARROW}`+
						   `${KEY_CODES.LEFT_ARROW}`+
						   `${KEY_CODES.RIGHT_ARROW}`+
						   `${KEY_CODES.LEFT_ARROW}`+
						   `${KEY_CODES.RIGHT_ARROW}`+
						   `${KEY_CODES.B}`+
						   `${KEY_CODES.A}`;//KONAMI_CODE;
		this.timer = null;
		this.keysBuffer = '';

		// saving the binded handler this way is in order for removing the handler on destroy
		let bindedKeyUpHandler = (e) => this.onKeyUp(e);
		this.$document.on('keyup', bindedKeyUpHandler);
		this.$scope.$on('$destroy', () => this.$document.off('keyup', bindedKeyUpHandler));
	}

	onKeyUp(event) {
		this.$timeout.cancel(this.timer);

		this.keysBuffer += event.which;

		this.timer = this.$timeout(()=>{
			this.$timeout.cancel(this.timer);
			this.keysBuffer = '';
		}, KONAMI_TYPE_DELAY);

		if (this.keysBuffer === this.konamiCode) {
			this.onSuccessfullyTypedKonamiCode();
		}
	}

	onSuccessfullyTypedKonamiCode() {
		if(this.jfBintrayKonamiCb && typeof this.jfBintrayKonamiCb === 'function') {
			this.jfBintrayKonamiCb();
		}
	}
}

JfBintrayKonamiController.$inject = ['$scope', '$element', '$attrs', '$document', '$timeout'];

export default function JfBintrayKonami() {
	return {
		restrict: 'A',
		scope           : {
			jfBintrayKonamiCb: '&?'
		},
		controller: JfBintrayKonamiController,
		controllerAs: '$ctrl',
		bindToController: true,
	};
}

JfBintrayKonami.META = {
	name: 'jfBintrayKonami'
};



// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-bintray-konami/jf_bintray_konami.js